import React from 'react';
import BackendText, { BackendHeading } from './BackendText';

const CategoryCard = ({ 
  category, 
  index,
  icon,
  className = '',
  isBackendContent = false
}) => {
  const displayCategory = category;
  
  const renderBulletPoints = (bullets) => {
    if (!Array.isArray(bullets) || bullets.length === 0) return null;
    
    return (
      <ul className="space-y-3">
        {bullets.map((bullet, i) => (
          <li key={i} className="flex items-start gap-3 text-gray-700">
            <div className="w-2 h-2 bg-black mt-2 flex-shrink-0"></div>
            {isBackendContent ? (
              <BackendText
                text={bullet}
                i18nKey={`projects_page.categories.${displayCategory.key}.bullets.${i}`}
                fallback={bullet}
                className="leading-relaxed"
              />
            ) : (
              <span className="leading-relaxed">{bullet}</span>
            )}
          </li>
        ))}
      </ul>
    );
  };
  
  return (
    <article
      className={`group bg-white border-l-4 border-black p-8 hover:border-gray-400 hover:bg-gray-50 transition-all duration-300 relative ${className}`}
    >
      {/* Category Number */}
      <div className="absolute top-4 right-4 w-8 h-8 border-2 border-black flex items-center justify-center text-xs font-black">
        {String(index + 1).padStart(2, '0')}
      </div>
      
      <div className="flex items-start gap-4 mb-6">
        <div className="w-16 h-16 border-2 border-black flex items-center justify-center text-2xl group-hover:bg-black group-hover:text-white transition-all duration-300">
          {icon}
        </div>
        <div className="flex-1">
          {isBackendContent ? (
            <BackendHeading
              text={displayCategory.title}
              i18nKey={`projects_page.categories.${displayCategory.key}.title`}
              fallback={displayCategory.title}
              className="text-xl font-black uppercase tracking-wider text-black mb-2 group-hover:text-gray-700 transition-colors duration-300"
            />
          ) : (
            <h3 className="text-xl font-black uppercase tracking-wider text-black mb-2 group-hover:text-gray-700 transition-colors duration-300">
              {displayCategory.title}
            </h3>
          )}
          <div className="w-12 h-1 bg-black group-hover:w-20 transition-all duration-300"></div>
        </div>
      </div>
      
      {isBackendContent ? (
        <BackendText
          text={displayCategory.desc}
          i18nKey={`projects_page.categories.${displayCategory.key}.desc`}
          fallback={displayCategory.desc}
          as="p"
          className="text-gray-700 mb-6 leading-relaxed"
        />
      ) : (
        <p className="text-gray-700 mb-6 leading-relaxed">{displayCategory.desc}</p>
      )}
      
      {renderBulletPoints(displayCategory.bullets)}
      
      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
    </article>
  );
};

export default CategoryCard;
